// Module
var code = `<ex-multi-occurrence-analyse multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;